import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { EquipmentApi } from '@vi-iot/client';
import { ViToastService } from '@vi-iot/ui';

import { DepartmentActions } from './department.actions';

@Injectable()
export class DepartmentEffects {
  getAllDepartments: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(DepartmentActions.getAllDepartments),
      switchMap(() =>
        this.api.getAllDepartments().pipe(
          map((payload) => DepartmentActions.getAllDepartmentsSuccess({ departments: payload })),
          catchError((err) => of(DepartmentActions.getAllDepartmentsError({ error: err })))
        )
      )
    );
  });

  updateDepartment: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(DepartmentActions.updateDepartment),
      switchMap((action) =>
        this.api.updateDepartment(action.installationId, action.departmentName).pipe(
          tap(() => {
            this.toastService.info({
              message: this.translateService.instant(
                '+INSTALLATIONS.INSTALLATION.DEPARTMENTS.CHANGE_SUCCESS'
              ),
            });
          }),
          map(() => DepartmentActions.updateDepartmentSuccess()),
          catchError((err) => {
            this.toastService.error({
              message: this.translateService.instant(
                '+INSTALLATIONS.INSTALLATION.DEPARTMENTS.CHANGE_ERROR'
              ),
            });

            return of(DepartmentActions.updateDepartmentError({ error: err }));
          })
        )
      )
    );
  });

  deleteDepartment: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(DepartmentActions.deleteDepartment),
      switchMap((action) =>
        this.api.deleteDepartment(action.installationId).pipe(
          tap(() => {
            this.toastService.info({
              message: this.translateService.instant(
                '+INSTALLATIONS.INSTALLATION.DEPARTMENTS.DELETE_SUCCESS'
              ),
            });
          }),
          map(() => DepartmentActions.deleteDepartmentSuccess()),
          catchError((err) => {
            this.toastService.error({
              message: this.translateService.instant(
                '+INSTALLATIONS.INSTALLATION.DEPARTMENTS.DELETE_ERROR'
              ),
            });

            return of(DepartmentActions.deleteDepartmentError({ error: err }));
          })
        )
      )
    );
  });

  constructor(
    private api: EquipmentApi,
    private actions$: Actions,
    private toastService: ViToastService,
    private translateService: TranslateService
  ) {}
}
